import { AppointmentFilterOptions, AppointmentsRepository } from "@/repositories/appointments.repository";
import { appointment_status } from "@/models/appointment.model";
import { CreateAppointmentPayload } from "@/app/pmc/appointments/appointments.entity.ts";
import { PropertyUnitsRepository } from "@/repositories/property-units.repository.ts";
import type { UnitForm } from "@/repositories/unit-records";
import { bookAppointment } from "@/services/appointment-booking.service";

export async function listAppointments(
  page: number,
  pageSize: number,
  filters: {
    status?: appointment_status;
    serviceParent?: string;
    vendor?: string;
    assignee?: string;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  },
  sortKey: string,
  sortOrder: "asc" | "desc"
) {
  return AppointmentsRepository.list(page, pageSize, filters, sortKey, sortOrder);
}

export const fetchParentCategories = () => AppointmentsRepository.listParentCategoriesForOrg();
export const fetchParentCategoriesForVendor = (vendorId: string) =>
  AppointmentsRepository.listParentCategoriesForVendor(vendorId);
export const listAppointmentFilterOptions = async (): Promise<AppointmentFilterOptions> =>
  AppointmentsRepository.listFilterOptions();
export const createAppointment = (payload: CreateAppointmentPayload) => bookAppointment(payload);
export const fetchVendorsForParent = (parent: string) => AppointmentsRepository.listVendorsForParent(parent);
export const fetchChildServices = (vendor: string, parent: string) =>
  AppointmentsRepository.listChildServices(vendor, parent);
export const fetchProperties = () => PropertyUnitsRepository.listForOrg();
export const fetchPropertiesForVendor = (vendorId: string) => PropertyUnitsRepository.listForVendor(vendorId as any);
export const fetchUnits = (propertyId: string) => PropertyUnitsRepository.listUnits(propertyId as any);
export const createUnit = (unit: UnitForm & { property: string }) => PropertyUnitsRepository.createUnit(unit);
export const fetchAppointment = (id: string) => AppointmentsRepository.getById(id);
export const fetchAppointmentLogs = (id: string) => AppointmentsRepository.listHistory(id);
